import React, { Component } from 'react';
import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";

const styles = () => ({
    subjectButton: {
        wordWrap: 'break-word',
        whiteSpace: 'normal',
        borderRadius: 0,
        backgroundColor: '#000000 !important',
        color: '#FFF',
        cursor: 'default'
    },
    orgLinkContainer: {
        width: '100%',
        background: '#000000 !important',
        color: '#FFF !important',
        textAlign: 'center',
        padding: '0.40625rem 1.25rem',
        lineHeight: '1.5',
        fontWeight: '400',
        margin: '10px auto',

        "&:hover": {
            background: '#febe10 !important',
            color: '#000000 !important',
        }
    },
    orgLink: {
        wordWrap: 'break-word',
        color: '#FFF',
        padding: '10px',

        "&:hover": {color: '#000000 !important'},
        "&:focus": {color: '#FFF !important'},
    }
});

class ProfileLinks extends Component {
    constructor(props) {
        super();
    }

    renderOrgButton(orgProfile) {
        const { name, fdo_link, gs_link } = orgProfile;
        const { classes } = this.props;
        const link = gs_link !== undefined ? gs_link : fdo_link;
        return (
            <div className={classes.orgLinkContainer}>
                <a className={classes.orgLink} href={link} target="_blank" rel="noopener noreferrer">
                    {name}
                </a>
            </div>
        )
    }

    renderSubjects(subject) {
        const { classes } = this.props;
        return (
            <Button 
                size="sm" 
                color="primary"
                className={classes.subjectButton} 
                value={subject} 
                onClick={null}
            >
                {subject}
            </Button> 
        )
    }

    render() {
        const { organizations, numOrganizations, subjects, numSubjects } = this.props;

        return (
            <GridContainer>
                {/* ---- ORGANIZATIONS ---- */}
                {
                    organizations && organizations.length > 0 ? 
                        <div>
                            <h6>Most important organizations</h6>
                            { organizations.slice(0, numOrganizations).map((orgProfile, index) => this.renderOrgButton(orgProfile)) }
                        </div>
                        : null
                }

                {/* ---- SUBJECTS ---- */}
                {
                    subjects && subjects.length > 0 ? 
                        <div>
                            <h6>Sample {numSubjects} subjects</h6>
                            { subjects.slice(0, numSubjects).map((subject, index) => this.renderSubjects(subject.description)) }
                        </div>
                        : null
                }
            </GridContainer>
        )
    }
}

ProfileLinks.propTypes = {
    classes: PropTypes.object,
    organizations: PropTypes.array,
    numOrganizations: PropTypes.number,
    subjects: PropTypes.array,
    numSubjects: PropTypes.number
}

export default withStyles(styles)(ProfileLinks);


// WEBPACK FOOTER //
// ./src/components/Article/common/ProfileLinks.jsx